<template>
  <footer class="footer">
    <div class="wavy-top"></div>
    <div class="footer-content">
      <div class="footer-links">
        <div class="link-group company-group">
          <h4>Company</h4>
          <a href="#about-us" class="tooltip-link" @click.prevent="scrollToSection('about-us')">About Us<span class="tooltip">Learn about our mission and values</span></a>
          <a href="#lifecycle" class="tooltip-link" @click.prevent="scrollToSection('lifecycle')">Standards<span class="tooltip">Our quality assurance standards</span></a>
          <a href="#services" class="tooltip-link" @click.prevent="scrollToSection('services')">Services<span class="tooltip">Professional services we offer</span></a>
          <a href="#faq" class="tooltip-link" @click.prevent="scrollToSection('faq')">FAQ<span class="tooltip">Frequently asked questions</span></a>
          <a href="#contact" class="tooltip-link" @click.prevent="scrollToSection('contact')">Contact Us<span class="tooltip">Get in touch with our team</span></a>
        </div>
        <div class="link-group products-group">
          <h4>Products</h4>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Insight</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Axiom</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Concord</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Merit</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Seamless</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Orbit</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Elevate</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL LinCard</a>
          <a href="#products" @click.prevent="scrollToSection('products')">EDUVAL Apply</a>
        </div>
        
        <div class="link-group">
          <h4>Resources</h4>
          <a href="#" @click.prevent="openResourceModal('blog')">Blog</a>
          <a href="#" @click.prevent="openResourceModal('help')">Help Center</a>
        </div>
        <div class="link-group">
          <h4>Contact</h4>
          <a href="mailto:info@eduval.net">info@eduval.net</a>
          <a href="tel:+966 114643421">+966 114643421</a>
          <div class="social-icons">            
            <a href="https://www.linkedin.com/company/eduval-higher-education-and-institutional-effectiveness-software-solutions/posts/?feedView=all" target='_blank' class="social-icon"><i class="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>
      <div class="demo-container">
        <button class="demo-button" @click="requestDemo">
          <i class="fas fa-headset"></i>
          Request a Demo
        </button>
      </div>
    </div>
    <div class="copyright">
      <p>&copy; 2023 Eduval. All rights reserved.</p>
    </div>
    <div class="back-to-top" @click="scrollToTop">
      <i class="fas fa-chevron-up"></i>
    </div>

    
    <!-- Resource Modal -->
    <transition name="fade">
      <div v-if="showResourceModal" class="resource-modal-overlay" @click.self="closeResourceModal">
        <div class="resource-modal">
          <button class="modal-close-btn" @click="closeResourceModal">
            <i class="fas fa-times"></i>
          </button>
          <div class="modal-header">
            <div class="modal-icon" :class="currentResource.iconClass">
              <i :class="currentResource.icon"></i>
            </div>
            <h3 class="modal-title">{{ currentResource.title }}</h3>
          </div>
          <div class="modal-content" v-html="currentResource.content">
          </div>
        </div>
      </div>
    </transition>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      showResourceModal: false,
      currentResource: {
        title: '',
        icon: '',
        iconClass: '',
        content: ''
      },
      resources: {
        'case-studies': {
          title: 'Case Studies',
          icon: 'fas fa-university',
          iconClass: 'case-studies-icon',
          content: `
            <h4>Success Stories from Educational Institutions</h4>
            <p>Explore how universities and colleges have transformed their operations using Eduval's suite of products.</p>
            
            <div class="case-study-item">
              <h5>University of Excellence</h5>
              <p>Improved accreditation compliance by 87% within one academic year after implementing AAMS.</p>
              <div class="case-study-stats">
                <div class="stat">
                  <span class="value">87%</span>
                  <span class="label">Compliance Improvement</span>
                </div>
                <div class="stat">
                  <span class="value">3x</span>
                  <span class="label">Faster Reporting</span>
                </div>
              </div>
            </div>
            
            <div class="case-study-item">
              <h5>National College of Engineering</h5>
              <p>Streamlined curriculum development process and reduced planning time by 65% with ICS.</p>
              <div class="case-study-stats">
                <div class="stat">
                  <span class="value">65%</span>
                  <span class="label">Time Saved</span>
                </div>
                <div class="stat">
                  <span class="value">98%</span>
                  <span class="label">Faculty Satisfaction</span>
                </div>
              </div>
            </div>
            
            <p class="coming-soon">More case studies coming soon. Contact us to learn how we can help your institution.</p>
          `
        },
        'blog': {
          title: 'BLOG ARTICLES',
          icon: 'fas fa-rss',
          iconClass: 'blog-icon',
          content: `
            <div style="background-color: #f5f5f5; padding: 20px; border: 3px solid #d1c06e; border-radius: 10px;">
              <h2 style="color: #333; text-align: center; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 30px; font-size: 24px; border-bottom: 3px solid #d1c06e; padding-bottom: 10px;">Academic Process Insights</h2>
              
              <div class="blog-categories">
                <div class="blog-category">
                  <h3 style="color: #333; font-size: 20px; text-transform: uppercase; border-bottom: 2px solid #d1c06e; padding-bottom: 8px; margin-bottom: 20px;">Faculty Management</h3>
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Optimizing Faculty Workload Distribution with FIS</h4>
                    <p>How the Faculty Information System revolutionizes workload management by balancing teaching, research, and service commitments while ensuring equity across departments.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Dr. Michael Chen</span>
                      <span><i class="fas fa-calendar-alt"></i> June 12, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                  
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Faculty Promotion & Evaluation: Data-Driven Decision Making</h4>
                    <p>Leveraging the FIS platform to create transparent evaluation processes and promotion pathways that recognize diverse faculty contributions.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Prof. Lisa Patel</span>
                      <span><i class="fas fa-calendar-alt"></i> May 22, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                </div>
                
                <div class="blog-category">
                  <h3 style="color: #333; font-size: 20px; text-transform: uppercase; border-bottom: 2px solid #d1c06e; padding-bottom: 8px; margin-bottom: 20px;">Curriculum & Syllabus</h3>
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Creating Outcome-Based Syllabi With ISS</h4>
                    <p>How the Integrated Syllabus System enables institutions to create consistent, measurable learning outcomes across courses while maintaining academic freedom.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Dr. Sarah Chen</span>
                      <span><i class="fas fa-calendar-alt"></i> June 5, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                  
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Curriculum Mapping Strategies with ICS</h4>
                    <p>Best practices for using the Integrated Curriculum System to visualize program progression, identify gaps, and ensure alignment with institutional goals.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Prof. James Wilson</span>
                      <span><i class="fas fa-calendar-alt"></i> May 15, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                </div>
                
                <div class="blog-category">
                  <h3 style="color: #333; font-size: 20px; text-transform: uppercase; border-bottom: 2px solid #d1c06e; padding-bottom: 8px; margin-bottom: 20px;">Accreditation & Planning</h3>
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Streamlining Accreditation Evidence Collection with AAMS</h4>
                    <p>How the Accreditation and Assessment Management System transforms the documentation process by automating evidence collection and organizing materials by standards.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Dr. Robert Johnson</span>
                      <span><i class="fas fa-calendar-alt"></i> April 30, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                  
                  <div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Strategic KPI Tracking with SPTS</h4>
                    <p>Leveraging the Strategic Planning and Performance Management System to define measurable objectives, track progress, and drive continuous improvement in your institution.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Dr. Emily Rodriguez</span>
                      <span><i class="fas fa-calendar-alt"></i> April 18, 2023</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                </div>
              </div>
              
              <div style="background: white; padding: 20px; border-radius: 8px; margin-top: 30px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-top: 4px solid #d1c06e;">
                <h3 style="color: #333; font-size: 20px; text-transform: uppercase; border-bottom: 2px solid #d1c06e; padding-bottom: 8px; margin-bottom: 20px;">Featured Article</h3>
                <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center;">
                  <div style="flex: 1; min-width: 280px;">
                    <h4 style="color: #333; font-size: 18px; margin-bottom: 10px;">Optimizing Academic Scheduling with TTMS</h4>
                    <p>A comprehensive guide to implementing the Timetabling Management System to create conflict-free schedules that maximize resource utilization while accommodating faculty and student preferences.</p>
                    <div class="post-meta">
                      <span><i class="fas fa-user"></i> Dr. Thomas Anderson</span>
                      <span><i class="fas fa-calendar-alt"></i> June 20, 2023</span>
                      <span><i class="fas fa-tag"></i> Academic Operations</span>
                    </div>
                    <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Read Full Article <i class="fas fa-arrow-right"></i></a>
                  </div>
                  <div style="flex: 1; min-width: 280px; display: flex; justify-content: center;">
                    <div style="width: 200px; height: 200px; background-color: #eee; border-radius: 10px; display: flex; align-items: center; justify-content: center;">
                      <i class="fas fa-calendar-alt" style="font-size: 80px; color: #d1c06e;"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `
        },
        'help': {
          title: 'HELP CENTER',
          icon: 'fas fa-question-circle',
          iconClass: 'help-icon',
          content: `
            <div style="background-color: #f5f5f5; padding: 20px; border: 3px solid #d1c06e; border-radius: 10px;">
              <h2 style="color: #333; text-align: center; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 30px; font-size: 24px; border-bottom: 3px solid #d1c06e; padding-bottom: 10px;">Help Center</h2>
              
              <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 30px;">
                <div style="background: white; padding: 25px; border-radius: 10px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
                  <div style="width: 80px; height: 80px; border-radius: 50%; background: rgba(209,192,110,0.1); margin: 0 auto 20px; display: flex; align-items: center; justify-content: center;">
                    <i class="fas fa-book" style="font-size: 40px; color: #d1c06e;"></i>
                  </div>
                  <h3 style="color: #333; font-size: 20px; margin-bottom: 15px;">Documentation</h3>
                  <p>Comprehensive guides and reference materials for all Eduval products</p>
                  <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Browse Docs <i class="fas fa-arrow-right"></i></a>
                </div>
                
                <div style="background: white; padding: 25px; border-radius: 10px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
                  <div style="width: 80px; height: 80px; border-radius: 50%; background: rgba(209,192,110,0.1); margin: 0 auto 20px; display: flex; align-items: center; justify-content: center;">
                    <i class="fas fa-video" style="font-size: 40px; color: #d1c06e;"></i>
                  </div>
                  <h3 style="color: #333; font-size: 20px; margin-bottom: 15px;">Video Tutorials</h3>
                  <p>Step-by-step video guides for common tasks and features</p>
                  <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Watch Videos <i class="fas fa-arrow-right"></i></a>
                </div>
                
                <div style="background: white; padding: 25px; border-radius: 10px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
                  <div style="width: 80px; height: 80px; border-radius: 50%; background: rgba(209,192,110,0.1); margin: 0 auto 20px; display: flex; align-items: center; justify-content: center;">
                    <i class="fas fa-headset" style="font-size: 40px; color: #d1c06e;"></i>
                  </div>
                  <h3 style="color: #333; font-size: 20px; margin-bottom: 15px;">Support</h3>
                  <p>Get help from our dedicated customer support team</p>
                  <a href="#" style="display: inline-block; background-color: #d1c06e; color: #333; padding: 10px 20px; border-radius: 30px; text-decoration: none; font-weight: bold; margin-top: 15px; text-transform: uppercase; letter-spacing: 1px;">Contact Us <i class="fas fa-arrow-right"></i></a>
                </div>
              </div>
              
              <div style="background: white; padding: 25px; border-radius: 10px; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
                <h3 style="color: #333; font-size: 22px; text-transform: uppercase; letter-spacing: 1px; border-bottom: 2px solid #d1c06e; padding-bottom: 10px; margin-bottom: 20px;">Frequently Asked Questions</h3>
                
                <div style="border-bottom: 1px solid #eee; padding: 15px 0;">
                  <div style="display: flex; align-items: center; cursor: pointer;">
                    <i class="fas fa-plus-circle" style="color: #d1c06e; font-size: 18px; margin-right: 15px;"></i>
                    <h4 style="color: #333; font-size: 18px; margin: 0;">How do I reset my password?</h4>
                  </div>
                  <div style="padding: 15px 0 5px 35px;">
                    <p>Click on the "Forgot Password" link on the login page. You'll receive an email with instructions to reset your password. If you don't receive the email, check your spam folder or contact support.</p>
                  </div>
                </div>
              </div>
            </div>
          `
        }
      }
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    requestDemo() {
      // Emit an event that will be caught by the parent component (Home.vue)
      this.$emit('request-demo');
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        // If element not found, scroll to top as fallback
        this.scrollToTop();
      }
    },
    openResourceModal(resourceId) {
      if (this.resources[resourceId]) {
        this.currentResource = this.resources[resourceId];
        this.showResourceModal = true;
        document.body.style.overflow = 'hidden'; // Prevent body scrolling
      }
    },
    closeResourceModal() {
      this.showResourceModal = false;
      document.body.style.overflow = ''; // Restore body scrolling
    }
  },
  beforeUnmount() {
    // Ensure body scrolling is restored when component is unmounted
    document.body.style.overflow = '';
  },
  mounted() {
    // ... existing code ...
    this.$nextTick(() => {
      // Initialize FAQ accordions whenever resource modal is opened
      document.addEventListener('click', (e) => {
        if (e.target && e.target.closest('.faq-question')) {
          const faqItem = e.target.closest('.faq-item');
          faqItem.classList.toggle('active');
        }
      });
    });
  }
}
</script>

<style>
/* Non-scoped styles for modal content that needs to apply to v-html content */
.case-study-item {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #7c4dff;
}

.case-study-stats {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.case-study-stats .stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.case-study-stats .value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #7c4dff;
}

.case-study-stats .label {
  font-size: 0.8rem;
  color: #777;
}

.coming-soon {
  font-style: italic;
  color: #888;
  text-align: center;
  margin-top: 1rem;
}

.blog-posts {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.blog-post {
  padding: 1.2rem;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  background-color: #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.blog-post:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #e6e6e6;
}

.blog-post h3 {
  color: #00755e;
  margin-bottom: 0.8rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.blog-post p {
  color: #333;
  font-size: 0.95rem;
  margin-bottom: 0.8rem;
  line-height: 1.5;
}

.post-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.post-meta span {
  color: #666;
  font-size: 0.85rem;
}

.blog-cta {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #00755e;
  color: white;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  margin-top: 1rem;
  transition: all 0.3s ease;
}

.blog-cta:hover {
  background-color: #005a47;
  transform: translateY(-2px);
}

.help-categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.help-category {
  padding: 1.5rem;
  background-color: #f7f9fb;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-left: 4px solid #00755e;
  margin-bottom: 1rem;
}

.help-category:hover {
  background-color: #eef5f3;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.help-category h3 {
  font-size: 1.2rem;
  color: #00755e;
  margin-top: 0;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.help-category p {
  color: #444;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0.8rem;
}

.help-category ul {
  padding-left: 1.2rem;
  margin-top: 0.8rem;
  margin-bottom: 0;
}

.help-category li {
  color: #555;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.faq-section {
  margin-top: 2rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1.5rem;
}

.faq-section h3 {
  color: #00755e;
  font-size: 1.4rem;
  margin-bottom: 1.2rem;
  font-weight: 600;
}

.faq-preview {
  padding: 1rem 1.5rem;
  background-color: #f7f9fb;
  border-radius: 8px;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid #00755e;
}

.faq-preview:hover {
  background-color: #eef5f3;
  transform: translateX(5px);
}

.faq-preview h4 {
  color: #333;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 500;
}

@media (max-width: 768px) {
  .help-categories {
    grid-template-columns: 1fr;
  }
  
  .case-study-stats {
    flex-direction: column;
  }
}
</style>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  padding: 4rem 2rem 1rem;
  position: relative;
}

.wavy-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23ffffff' fill-opacity='1' d='M0,64L60,80C120,96,240,128,360,138.7C480,149,600,139,720,122.7C840,107,960,85,1080,80C1200,75,1320,85,1380,90.7L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z'%3E%3C/path%3E%3C/svg%3E");
  background-size: cover;
  transform: translateY(-100%);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #d1c06e;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
}

.footer-logo:hover {
  transform: scale(1.05);
}

.logo {
  height: 40px;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 2px 5px rgba(0,0,0,0.3));
}

.logo:hover {
  transform: rotate(5deg);
}

.footer-links {
  display: grid;
  grid-template-columns: 1fr 1.8fr 1fr 1fr;
  gap: 2rem;
}

.link-group h4 {
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  position: relative;
  color: #d1c06e;
}

.link-group h4::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(to right, #d1c06e, #e0d394);
  transition: width 0.3s ease;
}

.link-group:hover h4::after {
  width: 50px;
}

.link-group a {
  display: block;
  color: #f5f5f5;
  text-decoration: none;
  margin-bottom: 0.8rem;
  transition: all 0.3s;
  position: relative;
  padding-left: 0;
}

.products-group a {
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.link-group a:hover {
  color: #d1c06e;
  padding-left: 8px;
}

.link-group a::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 0 4px 6px;
  border-color: transparent transparent transparent #d1c06e;
  opacity: 0;
  transition: all 0.3s ease;
}

.link-group a:hover::before {
  opacity: 1;
  left: -5px;
}

.social-icons {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.social-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #d1c06e;
  transform: scale(0);
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: -1;
}

.social-icon:hover {
  color: #333;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(209, 192, 110, 0.3);
}

.social-icon:hover::before {
  transform: scale(1);
}

.copyright {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 2rem;
  text-align: center;
  font-size: 0.9rem;
  color: #aaa;
}

.back-to-top {
  position: absolute;
  right: 30px;
  bottom: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #d1c06e;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  animation: bounce 2s infinite;
}

.back-to-top:hover {
  background-color: #e0d394;
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0,0,0,0.3);
  animation: none;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-5px);
  }
  60% {
    transform: translateY(-3px);
  }
}

.tooltip-link {
  position: relative;
}

.tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  bottom: 125%;
  background-color: rgba(51, 51, 51, 0.95);
  color: #f5f5f5;
  text-align: center;
  border-radius: 4px;
  padding: 8px 12px;
  min-width: 200px;
  font-size: 0.8rem;
  z-index: 10;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s, transform 0.3s, visibility 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-left: 2px solid #d1c06e;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 15px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(51, 51, 51, 0.95) transparent transparent transparent;
}

.tooltip-link:hover .tooltip {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.demo-container {
  display: flex;
  justify-content: center;  
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.demo-button {
  background-color: #d1c06e;
  color: #333;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 0.8rem 2rem;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(209, 192, 110, 0.3);
  position: relative;
  overflow: hidden;
}

.demo-button i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.demo-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: all 0.5s ease;
}

.demo-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(209, 192, 110, 0.4);
  background-color: #e0d394;
}

.demo-button:hover i {
  transform: scale(1.2);
}

.demo-button:hover::before {
  left: 100%;
}

.demo-tooltip {
  min-width: 250px;
  bottom: 135%;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  text-align: center;
}

.demo-tooltip::after {
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-link:hover .demo-tooltip {
  transform: translateX(-50%) translateY(0);
}

@media (max-width: 1100px) {
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .tooltip {
    min-width: 180px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 3rem 1.5rem 1rem;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .products-group a {
    white-space: normal;
    font-size: 0.9rem;
  }
  
  .back-to-top {
    right: 20px;
    bottom: 20px;
  }
  
  .demo-button {
    padding: 0.7rem 1.5rem;
    font-size: 1rem;
  }
  
  .modal-header {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
  
  .modal-icon {
    margin: 0 auto;
  }
  
  .modal-title {
    text-align: center;
  }
}

/* Resource Modal Styles */
.resource-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.resource-modal {
  background-color: white;
  border-radius: 12px;
  width: 95%;
  max-width: 700px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: modal-appear 0.3s ease-out;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
  color: #666;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}

.modal-close-btn:hover {
  background-color: rgba(0, 0, 0, 0.2);
  transform: rotate(90deg);
}

.modal-header {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid #eee;
  background: linear-gradient(to right, #fcfaf2, #fff);
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.case-studies-icon {
  background-color: rgba(209, 192, 110, 0.2);
  color: #d1c06e;
}

.blog-icon {
  background-color: rgba(209, 192, 110, 0.2);
  color: #d1c06e;
}

.help-icon {
  background-color: rgba(209, 192, 110, 0.2);
  color: #d1c06e;
}

.modal-title {
  font-size: 1.5rem;
  color: #333;
  margin: 0;
  flex: 1;
}

.modal-content {
  padding: 1.5rem;
  overflow-y: auto;
  max-height: calc(85vh - 100px);
}

.modal-content h4 {
  font-size: 1.2rem;
  color: #444;
  margin-top: 0;
  margin-bottom: 1rem;
}

.modal-content h5 {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 0.5rem;
}

.modal-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
}

/* Help popup general styles */
.help-popup, .blog-popup {
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.help-popup .popup-header, .blog-popup .popup-header {
  background-color: #00755e;
  color: white;
  border-radius: 12px 12px 0 0;
}

.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  padding: 2rem;
}

.popup-content {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 900px;
  padding: 2rem;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.popup-header h2 {
  color: #00755e;
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
}

.close-popup {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
  padding: 0.5rem;
}

.close-popup:hover {
  color: #00755e;
}

.help-categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Blog Popup Styles */
.blog-popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blog-popup-content {
  background-color: #f2f2f2;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  padding: 2rem;
}

.blog-popup-content h2 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  border-bottom: 2px solid #d1c06e;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.blog-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.blog-category {
  flex: 1;
  min-width: 280px;
}

.blog-category h3 {
  color: #333;
  font-size: 1.4rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #d1c06e;
  font-weight: 600;
}

.blog-post {
  background: #fff;
  border-radius: 6px;
  padding: 1.2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.blog-post:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.blog-post h4 {
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 0.7rem;
  line-height: 1.4;
}

.blog-post p {
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.post-meta {
  display: flex;
  font-size: 0.8rem;
  color: #777;
  margin-bottom: 0.7rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.post-meta span {
  display: flex;
  align-items: center;
}

.post-meta i {
  margin-right: 0.3rem;
}

.read-more {
  display: inline-block;
  background-color: #29B6B0;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.read-more:hover {
  background-color: #218e89;
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.read-more i {
  margin-left: 0.5rem;
  transition: transform 0.2s ease;
}

.read-more:hover i {
  transform: translateX(3px);
}

/* Help Center popup styles */
.help-categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.help-category {
  flex: none;
  min-width: auto;
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease;
}

.help-category:hover {
  transform: translateY(-5px);
}

.category-icon {
  font-size: 2.5rem;
  color: #d1c06e;
  margin-bottom: 1rem;
}

.help-category h3 {
  color: #333;
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.help-category p {
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 1.2rem;
  line-height: 1.5;
}

.help-link {
  display: inline-block;
  background-color: #d1c06e;
  color: #333;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.help-link:hover {
  background-color: #c2b268;
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.help-link i {
  margin-left: 0.5rem;
  transition: transform 0.2s ease;
}

.help-link:hover i {
  transform: translateX(3px);
}

.help-faq {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.help-faq h3 {
  color: #333;
  font-size: 1.4rem;
  margin-bottom: 1.2rem;
  border-bottom: 2px solid #d1c06e;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.faq-item {
  border-bottom: 1px solid #eee;
  padding: 1rem 0;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.faq-question i {
  color: #d1c06e;
  margin-right: 0.8rem;
  font-size: 1rem;
}

.faq-question h4 {
  color: #444;
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
}

.faq-answer {
  padding: 0.8rem 0 0.2rem 2.3rem;
  display: none;
}

.faq-answer p {
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
}

.faq-item.active .faq-question i {
  transform: rotate(45deg);
}

.faq-item.active .faq-answer {
  display: block;
}

/* Add JavaScript interaction for FAQ accordion */

@media (max-width: 992px) {
  .help-categories {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .help-categories {
    grid-template-columns: 1fr;
  }
  
  .blog-categories {
    flex-direction: column;
  }
  
  .read-more, .help-link {
    width: 100%;
    text-align: center;
  }
}

/* Blog Category Styles - More specific */
.blog-category-title {
  color: #333 !important;
  font-size: 1.5rem !important;
  margin-bottom: 1rem !important;
  padding-bottom: 0.8rem !important;
  border-bottom: 2px solid #d1c06e !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

/* Blog Post Styles */
.blog-post {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 1.5rem !important;
  margin-bottom: 1.5rem !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  border-top: 4px solid #d1c06e !important;
}

.blog-post:hover {
  transform: translateY(-8px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Read More Button Style */
.read-more {
  display: inline-block !important;
  background-color: #d1c06e !important;
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-decoration: none !important;
  padding: 10px 20px !important;
  border-radius: 30px !important;
  transition: all 0.3s ease !important;
  margin-top: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.read-more:hover {
  background-color: #333 !important;
  color: #fff !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important;
}

.read-more i {
  margin-left: 0.5rem !important;
  transition: transform 0.3s ease !important;
}

.read-more:hover i {
  transform: translateX(5px) !important;
}

/* Help Center Styles - More specific */
.help-categories {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 1.5rem !important;
  margin-bottom: 2.5rem !important;
}

.help-category {
  background: #fff !important;
  border-radius: 10px !important;
  padding: 2rem !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  text-align: center !important;
  transition: all 0.3s ease !important;
  border: none !important;
}

.help-category:hover {
  transform: translateY(-10px) !important;
  box-shadow: 0 15px 30px rgba(209, 192, 110, 0.2) !important;
}

.category-icon {
  font-size: 3rem !important;
  color: #d1c06e !important;
  margin-bottom: 1.5rem !important;
  background: rgba(209, 192, 110, 0.1) !important;
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto 1.5rem auto !important;
}

.help-heading {
  color: #333 !important;
  font-size: 1.4rem !important;
  margin-bottom: 1rem !important;
  font-weight: 700 !important;
}

.help-button {
  display: inline-block !important;
  background-color: #d1c06e !important;
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-decoration: none !important;
  padding: 10px 20px !important;
  border-radius: 30px !important;
  transition: all 0.3s ease !important;
  margin-top: 1rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.help-button:hover {
  background-color: #333 !important;
  color: #fff !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important;
}

.help-button i {
  margin-left: 0.5rem !important;
  transition: transform 0.3s ease !important;
}

.help-button:hover i {
  transform: translateX(5px) !important;
}

/* FAQ Section Styles */
.help-faq {
  background: #fff !important;
  border-radius: 10px !important;
  padding: 2rem !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.faq-heading {
  color: #333 !important;
  font-size: 1.6rem !important;
  margin-bottom: 1.5rem !important;
  border-bottom: 2px solid #d1c06e !important;
  padding-bottom: 0.8rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.faq-question i {
  color: #d1c06e !important;
  margin-right: 1rem !important;
  font-size: 1.2rem !important;
  transition: all 0.3s ease !important;
}

.faq-item.active .faq-question i {
  transform: rotate(45deg) !important;
  color: #333 !important;
}

/* Responsive Fixes */
@media (max-width: 992px) {
  .help-categories {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .help-categories {
    grid-template-columns: 1fr !important;
  }
  
  .blog-categories {
    flex-direction: column !important;
  }
  
  .read-more, .help-button {
    width: 100% !important;
    text-align: center !important;
  }
}
</style> 